import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { AbstractCombinedConfigurationService } from '../abstraction/abstract.combined-configuration.service';
import { ICombinedTransactionalSettings } from '../../interfaces/configuration/combined-transactional-settings.interface';

@Injectable({
  providedIn: 'root',
})
export class CombinedConfigurationService extends AbstractCombinedConfigurationService {
  private controller = `/manager/combinedconfiguration`;
  private urlGetCombinedTransactionalSettings = `${environment.apiUrl}${this.controller}/combinedtransactionalsettings`;
  private urlPostCombinedTransactionalSettings = `${environment.apiUrl}${this.controller}/combinedtransactionalsettings`;

  constructor(private http: HttpClient) {
    super();
  }

  getCombinedTransactionalSettings(
    routingNumber: string
  ): Promise<ICombinedTransactionalSettings | undefined> {
    return firstValueFrom(
      this.http.get<ICombinedTransactionalSettings>(
        `${this.urlGetCombinedTransactionalSettings}/${routingNumber}`
      )
    );
  }

  updateCombinedTransactionalSettings(
    settings: ICombinedTransactionalSettings
  ): Promise<IWebMessage | undefined> {
    return firstValueFrom(
      this.http.post<IWebMessage>(`${this.urlPostCombinedTransactionalSettings}`, settings)
    );
  }
}
